<template>
  <div class="main">
    <v-layout
      wrap
      justify-end
    >
      <v-flex xs2>
        <enterprise-filter />
      </v-flex>
    </v-layout>
    <h1>{{ enterpriseName }}</h1>
    <br />
    <status-table />
    <br/>
    <!-- <brightsignnetwork /> -->
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import EnterpriseFilter from './EnterpriseFilter'
  // import Brightsignnetwork from './Brightsignnetwork'
  import StatusTable from './StatusTable'
  export default {
    name: 'Index',
    components: {
      EnterpriseFilter,
      StatusTable,
      // Brightsignnetwork
    },
    props: {
    },
    data () {
      return {
        
      }
    },
    computed: {
      ...mapState('app',['enterpriseName']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
    },
    mounted(){
      
        console.log(process.env.VUE_APP_ENV)
    }
  }
</script>

<style scoped>
  .main {
    padding: 15px;
  }
</style>
